<template>
  <div class="">
    <TagsList type="full_treatment_template"
              class="mt-0 mb-4">
      {{ $t('tags_for_notifications') }}
    </TagsList>
    <div class="row">
      <template v-for="(f, find) in options.fields">
        <div :key="'form-field-'+find"
             v-if="f.form && !f.form.hidden && !(edit && f.unavailableonedit)"
             :class="f.form && f.form.classes ? f.form.classes : 'col-12'">
          <VariableInput :field="f"
                         :object="object"
                         :edit="edit"
                         :selectModels="selectModels"/>
          <div v-if="f.form.note" class="text-muted small">{{ $t(f.form.note) }}</div>
          <ValidationError :validationId="f.validation_id || f.id"/>
        </div>
      </template>
    </div>
    <div v-for="(tg, tind) in templateGroups"
         :key="`template-g-${tind}`">
      <div class="font-weight-bold mt-2 option-label">{{ $t(tg.title) }}</div>

      <draggable
          v-model="object.options"
          item-key="id"
          class="field-list"
      >
        <template #item="{ element, index }">

          <div :key="`tem-g-${tind}-o-${index}`"
               class="option-row"
               v-if="element.treatment_field === tg.id">
            <div class="row row-narrow">
              <div class="col-auto"  v-if="index != optionEdited">
                <a class="px-2 cursor-move drag-handle">
                  <DragSvg class="svg-light"/>
                </a>
              </div>
              <div class="col">
                <div v-if="index != optionEdited" class="prewrap word-break">{{ element.text }}</div>
                <div v-if="index == optionEdited">
                  <AutosizeTextArea v-model="element.text"/>
                </div>
              </div>
              <div class="col col-auto">
                <a v-if="index != optionEdited"
                   class="pointer"
                   tabindex="#"
                   @click="editOption(index)">
                  <EditSvg class="svg-stroke-light"/>
                </a>
                <a v-if="index == optionEdited"
                   class="pointer"
                   tabindex="#"
                   @click="optionEdited = null">
                  <TickSvg class="svg-light"/>
                </a>
                <a class="pointer ml-3"
                   tabindex="#"
                   @click="deleteOption(index)">
                  <DeleteSvg class="svg-stroke-light"/>
                </a>
              </div>
            </div>
          </div>

        </template>
      </draggable>

<!--      <template v-for="(o, oind) in object.options">-->
<!--        <div :key="`tem-g-${tind}-o-${oind}`"-->
<!--             class="option-row"-->
<!--             v-if="o.treatment_field === tg.id">-->
<!--          <div class="row">-->
<!--            <div class="col">-->
<!--              <div v-if="oind != optionEdited" class="prewrap">{{ o.text }}</div>-->
<!--              <div v-if="oind == optionEdited">-->
<!--                <AutosizeTextArea v-model="o.text"/>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col col-auto">-->
<!--              <a v-if="oind != optionEdited"-->
<!--                 class="pointer"-->
<!--                 tabindex="#"-->
<!--                 @click="editOption(oind)">-->
<!--                <EditSvg class="svg-stroke-light"/>-->
<!--              </a>-->
<!--              <a v-if="oind == optionEdited"-->
<!--                 class="pointer"-->
<!--                 tabindex="#"-->
<!--                 @click="optionEdited = null">-->
<!--                <TickSvg class="svg-light"/>-->
<!--              </a>-->
<!--              <a class="pointer ml-3"-->
<!--                 tabindex="#"-->
<!--                 @click="deleteOption(oind)">-->
<!--                <DeleteSvg class="svg-stroke-light"/>-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
      <div class="row mt-3">
        <div class="col">
          <AutosizeTextArea :placeholder="$t('text')"
                            :showlabel="false"
                            :minH="24"
                            :rows="1"
                            v-model="texts[tg.id]"/>
        </div>
        <div class="col col-auto">
          <button class="d-inline-block btn-themed btn-themed-squared btn-themed-outline"
                  :disabled="!texts[tg.id] || texts[tg.id].length < 1"
                  @click="add(tg.id)">{{ $t('add') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationError from "@/components/form/ValidationError"
import VariableInput from "@/components/form/VariableInput"
import {mapState} from "vuex"
import {templateGroupsWithTitles} from "@/dictionaries/dictionary"
// import InputGroup from "@/components/form/InputGroup"
import DeleteSvg from '@/assets/svg-vue/general/delete2.svg'
import EditSvg from '@/assets/svg-vue/general/edit2.svg'
import TickSvg from '@/assets/svg-vue/form/tick.svg'
import TagsList from "@/components/parts/crm/TagsList.vue"
import DragSvg from '@/assets/svg-vue/general/drag.svg'
import AutosizeTextArea from "@/components/form/AutosizeTextArea.vue"
import draggable from 'vuedraggable'

export default {
  name: "TemplateDatatableFormFullTreatmentTemplateForm",
  components: {
    AutosizeTextArea,
    TagsList,
    // InputGroup,
    ValidationError,
    VariableInput,
    DeleteSvg,
    TickSvg,
    EditSvg,
    DragSvg,
    draggable
  },
  props: {
    object: {},
    selectModels: {
      type: Object
    },
    options: {}
  },
  data() {
    return {
      texts: {},
      optionEdited: null,
      templateGroups: templateGroupsWithTitles
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      clinic: state => state.auth.clinic,
      model: state => state.datatable.viewModel,
    }),
    edit() {
      return !!this.object[this.options.primaryKey]
    },
  },
  methods: {
    add(group) {
      this.object.options.push({
        treatment_field: group,
        text: this.texts[group],
        template_id: this.object.id ?? null
      })
      this.texts[group] = ''
    },
    deleteOption(index) {
      this.optionEdited = null
      this.object.options.splice(index, 1)
    },
    editOption(index) {
      this.optionEdited = index
    }
  },
  created() {
    draggable.compatConfig = { MODE: 3 }
  },
  mounted() {

  },
  watch: {

  }
}
</script>

<style scoped lang="scss">
.option-label {
  font-size: 14px;
}
.option-row {
  padding: 7px 0;
  font-size: 14px;
  border-bottom: 1px dashed #DEE1E9;
}
</style>
